import { options, title } from 'Containers/steps/Consts'
import { t } from 'i18next'
import { ManageSubscriptionStep, ManageSubscriptionStepId } from 'types/manageSubscriptionTypes'

export function getLoginStep(): ManageSubscriptionStep {
  return {
    id: ManageSubscriptionStepId.Login,
    type: 'custom',
    allowNext: true,
    wordings: {
      title: t(`${ManageSubscriptionStepId.Login}.${title}`)
    }
  }
}
